module.exports = __webpack_public_path__ + "img/40_38_051_570.6beb864e.jpg";